import { BaseService } from "../../core/baseService";
import { ApiResult } from "../../core/types";
import { QueueItemDto } from "../../../models";
import {
  QueueServiceInterface,
  GetQueueItemsParams,
  PaginatedQueueResponse,
} from "../types/queue.types";

export class QueueService extends BaseService implements QueueServiceInterface {
  async getQueueItems(): Promise<ApiResult<QueueItemDto[]>> {
    return this.handleRequest<QueueItemDto[]>(
      this.client.get("/api/admin/queue/all"),
    );
  }

  async getPaginatedQueueItems(
    params: GetQueueItemsParams,
  ): Promise<ApiResult<PaginatedQueueResponse>> {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());
    if (params.slaFilter) queryParams.append("slaFilter", params.slaFilter);
    if (params.typeFilter !== undefined)
      queryParams.append("typeFilter", params.typeFilter.toString());
    if (params.searchTerm) queryParams.append("searchTerm", params.searchTerm);
    if (params.roomFilter) queryParams.append("roomFilter", params.roomFilter);
    if (params.statusFilter)
      queryParams.append("statusFilter", params.statusFilter);
    if (params.sortBy) queryParams.append("sortBy", params.sortBy);
    if (params.sortDescending !== undefined)
      queryParams.append("sortDescending", params.sortDescending.toString());
    if (params.dateFrom)
      queryParams.append("dateFrom", params.dateFrom.toISOString());
    if (params.dateTo)
      queryParams.append("dateTo", params.dateTo.toISOString());

    return this.handleRequest<PaginatedQueueResponse>(
      this.client.get(`/api/admin/queue?${queryParams.toString()}`),
    );
  }
}
